import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import Grid  from '@mui/material/Grid';
import {Form, Formik, useField} from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@mui/styles';
import { createTheme, Theme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import jwtAxios from '../../../../services/axiosInstance/ApiConfig';
import { showErrorMessage, showSuccessMessage } from '../../../../common/Toaster';
import { onGetAllCategories } from '../../../../store/actions/Category';
import { Item } from '../../../Layout/Main/ProductLists/ProductListItems/ProductDetails';
import { CategoryType } from '..';
import { getHeaders } from '../../../../store/actions/Auth';

const validationSchema = yup.object({
  category: yup
	.string()
	.required('Please enter category name!')
});

interface AddCategoryProps {
	setOpen: (open: boolean) => void;
	cancel: (from: string) => void;
	selectedCategory: CategoryType | null;
}

interface AddCategoryState {
	category: string;
}

const defaultTheme = createTheme()
export const useStyles = makeStyles((theme: Theme) => createStyles({
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	'& .MuiTextField-root': { m: 1, width: '100%' },
	signInButton: {
		fontSize: 16,
		marginLeft: '12px',
		textTransform: 'capitalize',
	},
	inputField: {
		width: '100%'
	}
}), { defaultTheme }
);

export const MyTextField = (props: any) => {
	const [field, meta] = useField(props);
	const classes: any = useStyles(props);
	const errorText = meta.error && meta.touched ? meta.error : '';
		return (
			<TextField
				{...props}
				{...field}
				helperText={errorText}
				style={{ width: '100%'}}
				error={!!errorText}
				InputProps={{
					classes: {
						root: classes.inputField,
					},
					...props.InputProps,
			}}
		/>
	);
};

const AddCategory = (props: AddCategoryProps) => {
	const { selectedCategory } = props;
	const dispatch = useDispatch()
	const [values] = useState<AddCategoryState>({
		category: selectedCategory && selectedCategory.name ? selectedCategory.name : '',
	})

  	const classes: any = useStyles(props);

	const submitHandler = (data: AddCategoryState, setSubmitting: any) => {
		setSubmitting(true);
		if(!selectedCategory) {
			jwtAxios.post('/category/add-category', { name: data.category })
			.then(response => {
				showSuccessMessage(response.data.msg)
				dispatch(onGetAllCategories())
			}).catch((err: any) => showErrorMessage(err))
		} else {
			jwtAxios.put('/category/edit-category/' + selectedCategory.id, 
				{ name: data.category }, { headers: getHeaders()})
			.then(response => {
				showSuccessMessage(response.data.msg)
				dispatch(onGetAllCategories())
			}).catch((err: any) => showErrorMessage(err))
		}
		props.setOpen(false)
		setSubmitting(false);
	}
  	return (
	  <Box className={classes.formContainer}>
	  	<Box component="h4" m="2">{selectedCategory ? 'Update' : 'Add New' } Category </Box>
		<Grid container display="flex" flexDirection="row">
			<Grid item sm={12}>
				<Item>
					<Formik
						validateOnChange={true}
						initialValues={{
							category: values.category
						}}
						validationSchema={validationSchema}
						onSubmit={(data, {setSubmitting}) => submitHandler(data, setSubmitting)}>
						{({isSubmitting}) => (
						<Form noValidate autoComplete="off">
							<Box display="flex" p={2} width="100%">
								<MyTextField
									required
									id="category-name"
									placeholder='category name'
									name='category'
									label='Category Name'
									variant='outlined'
								/>
							</Box>
							<Box
								mb={3}
								mr={2}
								display='flex'
								flexDirection={{xs: 'column', sm: 'row'}}
								justifyContent='flex-end'>
								<Button
									color="secondary"
									variant="outlined"
									className={clsx(classes.signInButton)}
									onClick={() => props.cancel('category')}
								>
									Cancel
								</Button>
								<Button
									type="submit"
									color="primary"
									variant="outlined"
									disabled={isSubmitting}
									sx={{ml: 1}}
									className={clsx(classes.signInButton)}>
									{selectedCategory ? 'Update' : 'Submit'}
								</Button>
							</Box>
						</Form>
					)}
					</Formik>
				</Item>
			</Grid>
		</Grid>
	</Box>
  );
};

export default AddCategory;
